import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import SshKeySelector from './SshKeySelector';
import ErrorList from '../ErrorList';
import { SshKeysStore } from '~/lib/store/SshKeysStore';
import { observer } from 'mobx-react';
import { action, makeObservable, observable } from 'mobx';
import SshKeyEditModal from '../ssh-keys/SshKeyEditModal';
import { SshKey } from '~/lib/ApiModel';

type SshKeysOptionProps = {
    keys: SshKeysStore;
    selectedIds: number[];
    onToggleSelectedId: (id: number) => unknown;
    errors: string[];
};

@observer
export default class SshKeyOptions extends React.Component<SshKeysOptionProps> {
    @observable
    showAddKeyModal = false;

    constructor(props: SshKeysOptionProps) {
        super(props);
        makeObservable(this);
    }

    @action
    showAddKey(show: boolean) {
        this.showAddKeyModal = show;
    }

    @action
    onAddKeyClose(newKey?: SshKey) {
        this.showAddKey(false);

        // If they are adding via this options panel, then they want to use it now regardless of the default flag they chose.
        if (newKey) {
            this.props.onToggleSelectedId(newKey.id);
        }
    }

    render() {
        const { keys, selectedIds, onToggleSelectedId, errors } = this.props;
        return (
            <>
                <p>Select your SSH key/s to deploy during installation, or add a new keypair.</p>
                <FormGroup>
                    <Label>SSH Keys</Label>
                    <SshKeySelector
                        sshKeys={keys.items}
                        selectedKeyIds={selectedIds}
                        onToggleSelectedId={(id) => onToggleSelectedId(id)}
                        onAddKeyClicked={() => this.showAddKey(true)}
                    />
                    <ErrorList errors={errors} />
                </FormGroup>
                {this.showAddKeyModal && (
                    <SshKeyEditModal store={keys} sshKey={undefined} onClose={(newKey) => this.onAddKeyClose(newKey)} />
                )}
            </>
        );
    }
}
